import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import AuthUser from './AuthUser'
import { useLocation } from 'react-router-dom';

const ProtectedRoutes = () => {
  const { getToken } = AuthUser()
  const location = useLocation();

  if (!getToken()) {
    const contieneVisit = location.pathname.includes('/visita');
    if (contieneVisit) {
      localStorage.setItem('token', JSON.stringify("Visit|Token"))
    } else {
      return <Navigate to={'/'} />
    }
  }

  return (
    <Outlet />
  )
}

export default ProtectedRoutes
